<template>
  <div class="page landing">
    <section class="content">
      <div class="main-kv"></div>
      <div class="detail">
        我们非常重视您的隐私及个人信息保护。请您认真阅读 
        <router-link to='/tmd/protocol/login'>《天美贷用户注册及服务协议》</router-link>
        <a @click="routerToProtocol('/tmd/protocol/privacy')" >《天美贷隐私政策》</a>
        全部条款，同意并接受全部条款后再开始使用我们的服务。
      </div>
      <div class="button" @click="$router.push('/?channel=H5-YZD')"></div>
      <p @click="back" class="back">返回</p>
    </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
      
    }
  },
  created () { 
    this.$bus.$emit('ready') 
  },
  methods: {
    back () {
      window.location.href = 'https://gateway-jr.jumei.com/api/inside/entrancenewnew'
    }
  }
}
</script>
<style lang='less' scoped>
@import "../../../assets/less/mixin.less";

.landing {
  padding-top: 170px;
  .main-kv {
    width:710px; 
    height: 655px;
    background: url(https://static.ndmicro.com/tmd/landing/yzd/images/img_ren.png) no-repeat;
    background-size: 100% 100%;
  }
  .detail {
    padding: 0px 70px;
    margin-top:137px ; 
    color: #999999;
    line-height: 33px;
    font-size: 24px;
    a {
      color: rgb(149, 204, 255);
    }
  }
  .button {
    width: 599px;
    height: 181px;
    background: url(https://static.ndmicro.com/tmd/landing/yzd/images/btn.png) no-repeat;
    background-size: 100% 100%;
    margin: 10px auto;
  }
  .back {
    color: #999999;
    line-height: 33px;
    font-size: 24px;
    text-align: center;
  }
}
</style>